import { FC } from 'react'

import { PrimaryAlert } from '../PrimaryAlert'
import { PaymentErrors } from '../PaymentErrorsAlert'

type ScheduleCheckoutErrorsProps = {
  name: PaymentErrors
}

const renderRespondError = (
  errorName: PaymentErrors,
): {
  title: string
  children: string
} => {
  switch (errorName) {
    case PaymentErrors.ACCOUNT_BALANCE:
      return {
        title: 'Account balance updated.',
        children: 'Please refresh the page to proceed with payment.',
      }
    case PaymentErrors.PAYPAL_FUNDS:
      return {
        title: 'Insufficient PayPal funds.',
        children: 'Add funds or use an alternative payment method.',
      }
    case PaymentErrors.PROMO_CODE:
      return {
        title: 'Promo code already used.',
        children: 'Try another coupon or proceed without it.',
      }
    case PaymentErrors.REFERENCE_TRANSACTION:
      return {
        title:
          'We`re sorry, but the payment account you selected is not valid.',
        children: 'Try using another payment method.',
      }
    case PaymentErrors.PAYPAL_TRANSACTION_REFUSED:
      return {
        title: 'PayPal declined the payment.',
        children:
          "Please try again - you'll be redirected to PayPal to approve the payment again.",
      }
    default:
      return {
        title: 'Oops! Something went wrong.',
        children: 'Please try again later or use a different payment method.',
      }
  }
}

export const ScheduleCheckoutErrors: FC<ScheduleCheckoutErrorsProps> = ({
  name,
}) => (
  <PrimaryAlert type='danger' hasCross={false} {...renderRespondError(name)} />
)
